/**
 * SampleProducts is an array of JSON objects containing sample products
 */
const SampleProducts = [
  {
    id: 1,
    name: "AVAX T-Shirt",
    price: 0.0100,
    image_url: "https://ih1.redbubble.net/image.2210792579.3669/rco,womens_premium_t_shirt,womens,x500,fafafa:ca443f4786,front-c,40,0,300,300-bg,f8f8f8.jpg",
    desc: "Dabbing Easter bunny HODLing AVAX",
    qty: 30
  },
  {
    id: 2,
    name: "LINK T-Shirt",
    price: 0.0128,
    image_url: "https://ih1.redbubble.net/image.1950348338.7594/ssrco,mens_premium_t_shirt,mens,101010:01c5ca27c6,front,square_three_quarter,x300-bg,f8f8f8.1.jpg",
    desc: "Chainlink See You on the Moon t-shirt",
    qty: 57
  },
  {
    id: 3,
    name: "GRT Journal",
    price: 0.0102,
    image_url: "https://ih1.redbubble.net/image.2260882070.0553/hj,300x-pad,300x300,f8f8f8.jpg",
    desc: "The Graph hardcover journal",
    qty: 43
  },
  {
    id: 4,
    name: "AAVE Curtain",
    price: 0.0310,
    image_url: "https://ih1.redbubble.net/image.2012870348.5512/ur,shower_curtain_closed_context,square,300x300.1.jpg",
    desc: "AAVE shower curtain, 71 x 74 inches",
    qty: 98
  },
  {
    id: 5,
    name: "SOL T-Shirt",
    price: 0.0092,
    image_url: "https://ih1.redbubble.net/image.2202518381.7027/ssrco,slim_fit_t_shirt,two_model,101010:01c5ca27c6,front,square_three_quarter,300x300.jpg",
    desc: "Solana My Retirement Plan t-shirt",
    qty: 123
  },
  {
    id: 6,
    name: "ETH Case",
    price: 0.0085,
    image_url: "https://ih1.redbubble.net/image.1373269076.7025/icr,iphone_12_soft,back,a,x300-pad,300x300,f8f8f8.jpg",
    desc: "Ethereum iPhone 12 shock absorbent case",
    qty: 214
  },
  {
    id: 7,
    name: "Polygon Logo",
    price: 0.0020,
    image_url: "https://ih1.redbubble.net/image.2229528085.4308/sss,small,product_square,300x300.jpg",
    desc: "Polygon To The Moon! sticker",
    qty: 17
  },
  {
    id: 8,
    name: "LINK Mask",
    price: 0.0047,
    image_url: "https://ih1.redbubble.net/image.1869798016.8105/ur,flat_mask_three_quarter,square,300x300.jpg",
    desc: "Two layers of soft 95% polyester",
    qty: 85
  },
  {
    id: 9,
    name: "HODL Chiffon",
    price: 0.0142,
    image_url: "https://ih1.redbubble.net/image.481948677.9432/ssrco,chiffon_top,womens,black,front,square_three_quarter,x300-bg,f8f8f8.1u8.jpg",
    desc: "HODL red background chiffon top",
    qty: 56
  },
  {
    id: 10,
    name: "Acala T-Shirt",
    price: 0.0093,
    image_url: "https://ih1.redbubble.net/image.2043110152.4257/ssrco,classic_tee,two_models,fafafa:ca443f4786,front,square_three_quarter,300x300.jpg",
    desc: "Acala Network classic t-shirt",
    qty: 38
  },
  {
    id: 11,
    name: "AVAX T-Shirt",
    price: 0.0116,
    image_url: "https://ih1.redbubble.net/image.2179442608.6415/ssrco,active_tshirt,mens,101010:01c5ca27c6,front,square_three_quarter,300x300.jpg",
    desc: "Avalanche to the moon active t-shirt",
    qty: 77
  },
  {
    id: 12,
    name: "DOGE Print",
    price: 1.0000,
    image_url: "https://ih1.redbubble.net/image.2221784184.0843/flat,300x,075,f-pad,300x300,f8f8f8.jpg",
    desc: "Elon Musk Dogecoin metal print",
    qty: 27
  }
];

export default SampleProducts;